<template><div><h1>string 处理工具</h1>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { trim } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>

trim(<span class="hljs-string">' 1024 '</span>) <span class="hljs-comment">// 1024</span>
</code></pre>
</div></template><script>
export default {
  head: {"title":"Vue string 工具函数 | VUX - Vue 移动端 UI 组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// string-310.vue?5992ebb0